import axios from "axios";

export default function ProjectCopyService(projectId) {
  return axios({
    method: 'POST',
    url: process.env.REACT_APP_API_HOST + "/project/" + projectId + "/copy",
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
